import React, { FC } from 'react'
import {
  Affilates,
  Contact,
  CTA,
  Guests,
  HeroWrapper,
  Shows,
  Benefits,
} from '../components/Home'
import { Reveal } from '../components/shared'

const Home: FC = () => {
  return (
    <>
      <HeroWrapper />
      <Reveal>
        <Benefits />
      </Reveal>
      <Reveal>
        <Affilates />
      </Reveal>
      <Reveal>
        <Guests />
      </Reveal>
      <Reveal>
        <Shows />
      </Reveal>
      <Reveal>
        <CTA />
      </Reveal>
      <Reveal>
        <Contact />
      </Reveal>
    </>
  )
}
export default Home
